<vi-page class="page-content" [sidenavs]="true" [footer]="true" [desktopMarginLeft]="true">
  <!-- left menu sidenav -->

  <app-sidenav left-sidenav [gatewaySerial]="gatewaySerial"></app-sidenav>

  <!-- sticky panel -->
  <app-sticky-panel
    stickyPanel
    data-at-black-sidenav
    [gatewaySerial]="gatewaySerial"
  ></app-sticky-panel>

  <!-- head -->
  <ng-container *ngIf="installationDetailsStore.getGatewayStatus() | async as gatewayStatus" head>
    <ng-container *ngIf="(installationDetailsStore.state$ | async).loaded" head>
      <app-installation-details-header></app-installation-details-header>
      <div class="menu-bar blur"></div>
    </ng-container>
  </ng-container>

  <!-- body -->
  <div body class="blur">
    <div>
      <h1>{{ '+INSTALLATION_DETAILS.DASHBOARD' | translate }}</h1>
      <app-feature-tiles-grid class="grid">
        <app-features-container *ngFor="let container of this.data" header="{{ container.header }}">
          <app-feature-tile
            *ngFor="let tile of container.tiles"
            feature
            data-at-mocked
            label="{{ tile.label }}"
            value="{{ tile.value }}"
          >
          </app-feature-tile>
        </app-features-container>
      </app-feature-tiles-grid>
    </div>
  </div>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
</vi-page>
